// extracted by mini-css-extract-plugin
export default {"brandBar":"styles_brandBar__azy+w","logo":"styles_logo__pWikM","modalLogo":"styles_modalLogo__MAWZD"};